<template>
    <div id="app" :class="isIe">
        <div class="linesBg">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <Preloader v-if="!isLoaded" v-on:updateLoaderState="updateLoaderState"/>
        <template v-else>

            <div class="logoWrapper" ref="logo">
                <router-link to="/"><h1 class="logo">Kévin Rousseau</h1></router-link>
            </div>

            <MainNav />
            <ToggleLanguage />
            <router-view />
        </template>
    </div>
</template>

<script>
import {TweenMax} from 'gsap'

import Preloader from './components/Preloader/Preloader'
import MainNav from './components/MainNav/MainNav'
import ToggleLanguage from './components/ToggleLanguage/ToggleLanguage'
const { detect } = require('detect-browser');

export default {
    name: 'app',
    data () {
        return {
            isLoaded: false,
            isIe: false
        }
    },
    components: {
        Preloader,
        MainNav,
        ToggleLanguage
    },
    mounted: function(){
        const browser = detect();
        this.isIe = browser.name == 'ie' || browser.name == 'edge' ? 'ie' : false
    },
    methods: {
        updateLoaderState: function(){
            this.isLoaded = true

            setTimeout(_ => {
                TweenMax.to([this.$refs.logo, document.querySelector('.mainNav'), document.querySelector('.lang')], 1.2, {autoAlpha: 1})
            }, 0)
        }
    }
}
</script>

<style lang="scss">
    @import './assets/scss/utils';

    .logoWrapper{
        position: fixed;
        top: calc(50% - 10px);
        left: 0;
        display: inline-block;
        margin: 0;
        z-index: 1;
        transform: rotate(-90deg) translateY(-100px);
        opacity: 0;
        visibility: hidden;

        .logo{
            color: $white;
            letter-spacing: 1em;
            font-family: $robotoCB;
            font-size: 1.3em;
            text-transform: uppercase;
        }

        a, a:visited{
            text-decoration: none;
            columns: $white;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue